import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const GirlsWeightclasses = () => {

  const location = useLocation()
  const genderId = location.pathname.split("/")[2]
  const classificationId = location.pathname.split("/")[3]

  console.log("gender is " + genderId + " classification is " + classificationId)

  return (
    <div className="weightclass_div">
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/100`}>
          <button class="wc_button">
            100
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/105`}>
          <button class="wc_button">
            105
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/110`}>
          <button class="wc_button">
            110
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/115`}>
          <button class="wc_button">
            115
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/120`}>
          <button class="wc_button">
            120
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/125`}>
          <button class="wc_button">
            125
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/130`}>
          <button class="wc_button">
            130
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/135`}>
          <button class="wc_button">
            135
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/140`}>
          <button class="wc_button">
            140
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/145`}>
          <button class="wc_button">
            145
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/155`}>
          <button class="wc_button">
            155
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/170`}>
          <button class="wc_button">
            170
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/190`}>
          <button class="wc_button">
            190
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/235`}>
          <button class="wc_button">
            235
          </button>
        </Link>
    </div>
  )
}

export default GirlsWeightclasses